// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__cXP6h","recaptcha":"App_recaptcha__O075L"};